import {
  Obj
} from '../../lib/Object.lib';
import {
  trim
} from '../../lib/String.lib';
import Box from '../Layout/Wrappers/Box';
import TextField from '../Layout/Wrappers/TextField';

export default function FilterIdColumn({
  column: {
    id: columnId,
  },
  filters = {},
  setFilter = () => { },
}) {
  return (
    <Box row flex1>
      <TextField disabledBlurExport
        className="mr-1 w-100"
        style={{ width: 120 }}
        value={trim(Obj(filters[columnId]).$id) || undefined}
        onChange={(event) => {
          let value = trim(event.target.value);
          setFilter({
            columnId,
            value: value.length ? { '$id': value } : undefined
          });
        }}
      />
    </Box>
  );
}
